export { default } from './SectionProducts';